import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { links } from '@/utils/featureToggles'

interface Props {
  tab: MLWithdrawalAutomationTab
}

export enum MLWithdrawalAutomationTab {
  GLOBAL_CONTROLS = 'Global Controls',
  OVERRIDES = 'Overrides',
}

export const MLWithdrawalAutomationNavigation: React.FC<Props> = (props) => {
  const navigate = useNavigate()

  const handleTabClick = (tab: string) => {
    switch (tab) {
      case MLWithdrawalAutomationTab.OVERRIDES:
        return navigate(links.administrationMlWithdrawalAutomationOverrides.url)

      case MLWithdrawalAutomationTab.GLOBAL_CONTROLS:
      default:
        return navigate(links.administrationMlWithdrawalAutomationGlobalControls.url)
    }
  }

  return (
    <div>
      <Tabs value={props.tab} onValueChange={handleTabClick} className='mt-2'>
        <TabsList>
          <TabsTrigger value={MLWithdrawalAutomationTab.GLOBAL_CONTROLS}>
            {MLWithdrawalAutomationTab.GLOBAL_CONTROLS}
          </TabsTrigger>
          <TabsTrigger value={MLWithdrawalAutomationTab.OVERRIDES}>
            {MLWithdrawalAutomationTab.OVERRIDES}
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  )
}
